import React from "react"
import { graphql } from "gatsby"
import CommonTemplate from "templates/common-template"
import { Box, Flex } from "theme-ui"
import styled from "@emotion/styled"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import SideNavBox from "components/lists/side-nav-box-list"
import GetHelp from "components/get-help"

const ResourceWrapper = styled.div`
    position: relative;
    text-align: center;
    margin-bottom: 3rem;
    display: flex;
    flex-direction: row;
    z-index: 10;

    & .resources-wrapper {
        justify-content: space-between;
        flex-wrap: wrap;
    }
    & .tab-wrapper {
        flex: 0 0 70%;
    }
    & .side-box-wrapper {
        flex-direction: column;
        flex: 0 0 30%;
        margin-top: -0.5rem;
        padding: 0 1rem;
    }

    & .react-tabs__tab {
        color: ${(props) => props.theme.colors.secondary};
    }
    & .react-tabs__tab:focus {
        box-shadow: none;
    }
    & .react-tabs__tab-list {
        border: none;
    }
    & .react-tabs__tab--selected {
        background: transparent;
        border: none;
        border-bottom: 2px solid ${(props) => props.theme.colors.accent_blue};
        color: ${(props) => props.theme.colors.accent_blue};
    }
    & table.gsc-input tr td:first-of-type {
        width: 88%;
    }

    @media (max-width: ${(props) => props.theme.breakpoints[4]}) {
        flex-direction: column;
        & .resources-wrapper {
            justify-content: center;
            padding: 0;
        }
        & table.gsc-input tr td:first-of-type {
            width: 93%;
        }
        & .side-box-wrapper {
            margin-top: 1rem;
            padding: 0;
        }
    }

    @media (max-width: ${(props) => props.theme.breakpoints[2]}) {
        & table.gsc-input tr td:first-of-type {
            width: 90%;
        }
    }

    @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
        & table.gsc-input tr td:first-of-type {
            width: 87%;
        }
    }
`

// markup
const IndexPage = ({ location, data, pageContext }) => {
    const { pageData, posts } = data
    const modifiedData = { pageData: { ...pageData, ...data.category } }
    const prefix = process.env.PREFIX_SLUG

    const customJsx = (
        <>
            {/* <Flex sx={{paddingBottom: "2rem"}}>
                <Box>
                    <h3>{pageData.published_date}</h3>
                    <BorderBottom />
                    <br />
                    <GatsbyImage
                        image={getImage(pageData.image)}
                        alt={pageData.title}
                    />
                    <div
                        dangerouslySetInnerHTML={{
                            __html: pageData.Description,
                        }}
                    ></div>
                </Box>
            </Flex> */}
            <ResourceWrapper>
                <Box className="tab-wrapper">
                    <Box className="resources-wrapper">
                        <GatsbyImage
                            image={getImage(pageData.image)}
                            alt={pageData.title}
                        />
                        <div
                            dangerouslySetInnerHTML={{
                                __html: pageData.Description,
                            }}
                        ></div>
                    </Box>
                </Box>
                <Flex className="side-box-wrapper">
                    <SideNavBox
                        title="Recent Post (up to 5)"
                        data={posts.edges}
                        prefix={prefix}
                        slug="resources/"
                    />
                </Flex>
            </ResourceWrapper>
            <GetHelp />
        </>
    )

    const arrData = {
        location,
        data: modifiedData,
        customElement: customJsx,
        parentLink: "resources",
    }

    return <CommonTemplate {...arrData} />
}

export default IndexPage

export const query = graphql`
    query ResourcesPostQuery($slug: String!) {
        pageData: strapiArticle(
            category: { slug: { eq: "resources" } }
            Post_Type: { eq: "Blog_Post" }
            slug: { eq: $slug }
        ) {
            title
            Description
            published_date
            image {
                childImageSharp {
                    gatsbyImageData(
                        placeholder: DOMINANT_COLOR
                        width: 900
                        height: 300
                    )
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
            }
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
        }
        category: strapiPage(
            slug: { eq: "wns-resources" }
            company: { shortname: { eq: "WNS" } }
        ) {
            category {
                name
                subtitle
                category_img {
                    childImageSharp {
                        gatsbyImageData(placeholder: BLURRED)
                    }
                }
            }
        }
        posts: allStrapiArticle(
            sort: { fields: published_date, order: DESC }
            filter: {
                category: { slug: { eq: "resources" } }
                Post_Type: { eq: "Blog_Post" }
            }
            limit: 5
        ) {
            edges {
                node {
                    summary
                    Description
                    category {
                        name
                        slug
                    }
                    menu_title
                    slug
                    title
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                width: 400
                                height: 400
                            )
                        }
                    }
                    author {
                        name
                    }
                    tags {
                        name
                        slug
                    }
                    published_date
                }
            }
        }
    }
`
